import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumnentLibraryComponent } from './components/documnent-library/documnent-library.component';
import { DocumentlibraryService } from './service/documentlibrary.service';
import { DocumentlibraryConstantsService } from './service/documentlibrary-constants.service';
import { SharedModule } from "../shared/shared.module";
import { DocumentLibraryRoutingModule } from './document-library-routing.module';


@NgModule({
  declarations: [DocumnentLibraryComponent],
  imports: [
    CommonModule,
    DocumentLibraryRoutingModule,
    SharedModule
  ],
  providers: [
    DocumentlibraryService,
    DocumentlibraryConstantsService,
  ],
})
export class DocumentLibraryModule { }
